<template>
    <div id="time-page">
        <div class="productactions" id="productactions">
            <div
                class="productaction"
                id="registerTime"
                @click="onRegisterTime">
                <p class="productactiontitle">{{ trans('pages.time.register_time') }}</p>
                <div class="productactionimgdiv">
                    <i class="fa fa-clock-o fa-3x" />
                </div>
            </div>
            <div
                class="productaction"
                id="registerBreak"
                @click="onRegisterBreak">
                <p class="productactiontitle">
                    <template v-if="showTikklokBreakTitle">
                        {{ trans('pages.time.stop_break') }}
                    </template>
                    <template v-else>{{ trans('pages.time.start_break') }}</template>
                </p>
                <div class="productactionimgdiv">
                    <i class="material-icons md-48">smoking_rooms</i>
                </div>
            </div>
        </div>

        <div>
            <div class="timeelement">
                <p>
                    {{ trans('pages.time.start_workday') }}
                    <template v-if="getTimeRegistration(0)">
                        {{ getTimeRegistration(0) }}
                    </template>
                    <template v-else>....</template>
                </p>
            </div>
            <div class="timeelement">
                <p>
                    {{ trans('pages.time.start_pause') }}
                    <template v-if="getTimeRegistration(1)">
                        {{ getTimeRegistration(1) }}
                    </template>
                    <template v-else>....</template>
                </p>
            </div>
            <div class="timeelement">
                <p>
                    {{ trans('pages.time.end_pause') }}
                    <template v-if="getTimeRegistration(2)">
                        {{ getTimeRegistration(2) }}
                    </template>
                    <template v-else>....</template>
                </p>
            </div>
            <div class="timeelement">
                <p>
                    {{ trans('pages.time.end_workday') }}
                    <template v-if="getTimeRegistration(3)">
                        {{ getTimeRegistration(3) }}
                    </template>
                    <template v-else>....</template>
                </p>
            </div>
            <div class="timeelement">
                <p>
                    {{ trans('pages.time.total_smoke_time') }}
                    <template v-if="totalSmokeTime">
                        {{ totalSmokeTime }}
                    </template>
                    <template v-else>....</template>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Tikklok from '../shared/Tikklok';
import { showInfoMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    mounted() {
        Tikklok.populateTimeElements();
        Tikklok.populateBreaks();
        const title = this.trans('pages.time.page_title', { location: this.userLocation });
        this.$store.commit('general/setPageTitle', title, { root: true });
    },
    computed: {
        ...mapGetters({
            totalSmokeTime: 'currentUser/getTotalSmokeTime',
            showTikklokBreakTitle: 'currentUser/getShowTikklokBreakTitle',
            userLocation: 'currentUser/getUserLocation',
            getTimeRegistration: 'currentUser/getTimeRegistration',
        }),
    },
    methods: {
        onRegisterTime() {
            Tikklok.registerTime(() => {
                showInfoMessage(this.trans('pages.time.time_registered'));
            });
        },
        onRegisterBreak() {
            Tikklok.registerBreak(() => {
                showInfoMessage(this.trans('pages.time.break_registered'));
            });
        },
    },
};
</script>
